var _path, _path2, _path3, _g, _g2, _path4, _g3, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMedal(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 241,
    height: 311,
    viewBox: "0 0 241 311",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M104.141 65.4224L107.615 70.8387L113.042 74.3062L107.615 77.7738L104.141 83.1901L100.667 77.7738L95.2398 74.3062L100.667 70.8387L104.141 65.4224Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M71.2252 90.2368L72.9623 92.945L75.6757 94.6787L72.9623 96.4125L71.2252 99.1207L69.488 96.4125L66.7747 94.6787L69.488 92.945L71.2252 90.2368Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M161.677 147.568L163.414 150.276L166.127 152.01L163.414 153.743L161.677 156.451L159.939 153.743L157.226 152.01L159.939 150.276L161.677 147.568Z",
    fill: "white"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_677:4504)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M120.484 230.278L78.5081 252.362V215.988V179.614V175.717H162.46V252.362L120.484 230.278Z",
    fill: "#2A62BF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120.484 230.277L105.19 238.328V175.717L135.778 175.716V238.328L120.484 230.277Z",
    fill: "white"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_d_677:4504)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M116.561 23.6088C118.746 21.1791 122.555 21.1791 124.74 23.6088L139.169 39.6528C141.203 41.9148 144.291 42.9171 147.266 42.2812L168.389 37.7655C171.587 37.0818 174.672 39.3234 175.009 42.5766L177.231 63.9919C177.545 67.0235 179.459 69.6547 182.246 70.888L201.968 79.615C204.963 80.9404 206.143 84.5735 204.499 87.4061L193.692 106.02C192.16 108.659 192.16 111.917 193.692 114.555L204.499 133.169C206.143 136.002 204.963 139.635 201.968 140.96L182.246 149.687C179.459 150.921 177.545 153.552 177.231 156.583L175.009 177.999C174.672 181.252 171.587 183.494 168.389 182.81L147.266 178.294C144.291 177.658 141.203 178.661 139.169 180.923L124.74 196.967C122.555 199.396 118.746 199.396 116.561 196.967L102.133 180.923C100.098 178.661 97.0104 177.658 94.0355 178.294L72.9125 182.81C69.7142 183.494 66.6295 181.252 66.2921 177.999L64.0708 156.583C63.7564 153.552 61.8429 150.921 59.0557 149.687L39.3335 140.96C36.3383 139.635 35.1581 136.002 36.8026 133.169L47.6092 114.555C49.1412 111.917 49.1412 108.659 47.6092 106.02L36.8026 87.4061C35.1581 84.5735 36.3383 80.9404 39.3335 79.615L59.0557 70.888C61.8429 69.6547 63.7564 67.0235 64.0708 63.9919L66.2921 42.5766C66.6295 39.3234 69.7142 37.0818 72.9125 37.7655L94.0355 42.2812C97.0104 42.9171 100.098 41.9148 102.133 39.6528L116.561 23.6088Z",
    fill: "url(#paint0_linear_677:4504)",
    stroke: "url(#paint1_linear_677:4504)",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter2_i_677:4504)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 120.651,
    cy: 112.211,
    rx: 55.4967,
    ry: 55.3894,
    fill: "url(#paint2_linear_677:4504)"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M175.147 112.211C175.147 142.248 150.75 166.6 120.651 166.6C90.5511 166.6 66.1539 142.248 66.1539 112.211C66.1539 82.1744 90.5511 57.8216 120.651 57.8216C150.75 57.8216 175.147 82.1744 175.147 112.211Z",
    stroke: "url(#paint3_linear_677:4504)",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter3_i_677:4504)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 121.036,
    cy: 112.211,
    rx: 43.9349,
    ry: 43.8499,
    fill: "url(#paint4_linear_677:4504)"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M163.471 112.211C163.471 135.597 144.475 154.561 121.036 154.561C97.5971 154.561 78.6011 135.597 78.6011 112.211C78.6011 88.8245 97.5971 69.8611 121.036 69.8611C144.475 69.8611 163.471 88.8245 163.471 112.211Z",
    stroke: "url(#paint5_linear_677:4504)",
    strokeWidth: 3
  }))), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M64.9287 179.455L174.968 37.849C173.095 35.6057 168.569 35.9796 166.54 36.4469C163.886 37.07 156.894 38.6902 150.151 40.1857C143.408 41.6812 139.849 38.9394 138.913 37.3816C136.415 34.5775 130.297 27.7543 125.802 22.8939C121.306 18.0335 117.061 20.5572 115.5 22.4266C112.535 25.8538 105.76 33.6429 102.389 37.3817C99.0176 41.1205 96.6139 41.432 95.8335 41.1205C90.3706 39.8742 78.0399 37.1012 72.4208 35.9796C66.8018 34.858 65.0849 39.5626 64.9288 42.0551C64.3044 47.3517 62.9621 58.8796 62.5875 62.6184C62.2129 66.3572 60.8706 68.2266 60.2462 68.6939C54.6272 71.1865 42.2653 76.7323 37.7701 78.9756C33.2748 81.2189 34.0241 85.5185 34.9606 87.3878C37.614 91.7498 43.4828 101.502 45.7304 105.614C47.978 109.727 47.2912 112.313 46.6669 113.092C44.1695 117.765 38.4255 128.234 35.4287 132.721C32.4319 137.207 35.4287 140.51 37.3017 141.6C43.0768 144.248 55.3763 149.826 58.3731 150.947C61.3699 152.069 62.4313 155.153 62.5874 156.555L64.9287 179.455Z",
    fill: "url(#paint6_linear_677:4504)"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter4_d_677:4504)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M123.609 117.821C125.265 119.414 126.178 121.532 126.178 123.786C126.178 123.815 126.177 123.845 126.177 123.874C130.427 119.83 149.529 101.653 149.537 101.645L141.097 93.366L119.299 113.675L123.609 117.821Z",
    fill: "url(#paint7_linear_677:4504)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M120.115 126.303C119.111 127.26 117.483 127.26 116.48 126.303C115.476 125.345 115.476 123.791 116.48 122.834C117.483 121.876 119.111 121.876 120.115 122.834C121.118 123.791 121.118 125.345 120.115 126.303ZM122.622 120.12L120.794 118.375L105.821 104.085L96.8364 112.66L111.809 126.95L113.638 128.695C116.119 131.063 120.141 131.063 122.622 128.695C125.103 126.327 125.103 122.488 122.622 120.12Z",
    fill: "url(#paint8_linear_677:4504)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_677:4504",
    x: 34.5081,
    y: 145.716,
    width: 171.952,
    height: 164.645,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 14
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 22
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.164706 0 0 0 0 0.384314 0 0 0 0 0.74902 0 0 0 0.27 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_677:4504"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_677:4504",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_d_677:4504",
    x: 0.557039,
    y: 0.286522,
    width: 240.187,
    height: 248.002,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 14
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 17
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.883333 0 0 0 0 0.674768 0 0 0 0 0.257639 0 0 0 0.35 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_677:4504"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_677:4504",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_i_677:4504",
    x: 65.1539,
    y: 56.8216,
    width: 110.993,
    height: 112.179,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1.4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.895833 0 0 0 0 0.607381 0 0 0 0 0.138108 0 0 0 0.74 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_677:4504"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter3_i_677:4504",
    x: 77.1011,
    y: 68.3611,
    width: 87.8698,
    height: 88.6998,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1.4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.9875 0 0 0 0 0.653868 0 0 0 0 0.111094 0 0 0 0.44 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_677:4504"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter4_d_677:4504",
    x: 96.5364,
    y: 93.366,
    width: 53.3006,
    height: 38.6046,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1.2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.15
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 0.48 0 0 0 0 0 0 0 0 0.2 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_677:4504"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_677:4504",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_677:4504",
    x1: 120.651,
    y1: 16.8182,
    x2: 120.651,
    y2: 203.757,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FADE83"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F5BA56"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_677:4504",
    x1: 120.651,
    y1: 16.8182,
    x2: 120.651,
    y2: 203.757,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF0BC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.40625,
    stopColor: "#FFF0BC",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_677:4504",
    x1: 120.651,
    y1: 56.8216,
    x2: 120.651,
    y2: 167.6,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F7C860"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F2A440"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_677:4504",
    x1: 120.651,
    y1: 56.8216,
    x2: 120.651,
    y2: 167.6,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F6D373",
    stopOpacity: 0.17
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FAD97C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_677:4504",
    x1: 121.036,
    y1: 68.3611,
    x2: 121.036,
    y2: 156.061,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FADE83"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F5BA56"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_677:4504",
    x1: 121.036,
    y1: 68.3611,
    x2: 121.036,
    y2: 156.061,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF0BC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.40625,
    stopColor: "#FFF0BC",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_677:4504",
    x1: 148.746,
    y1: 38.3163,
    x2: 104.718,
    y2: 179.504,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0.27
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_677:4504",
    x1: 134.418,
    y1: 93.366,
    x2: 134.418,
    y2: 123.874,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF7D5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FEE584"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_677:4504",
    x1: 110.66,
    y1: 104.085,
    x2: 110.66,
    y2: 130.471,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF7D5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FEE584"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMedal);
export default __webpack_public_path__ + "static/media/medal.267d7afe.svg";
export { ForwardRef as ReactComponent };